import { render, staticRenderFns } from "./TrackersList.vue?vue&type=template&id=db481350&scoped=true&"
import script from "./TrackersList.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackersList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db481350",
  null
  
)

export default component.exports